import styled from "@emotion/styled";
import { Player } from "@lottiefiles/react-lottie-player";

import IconHeadphoneSvg from "./headphone.svg";

export const StyledIconHeadphoneSvg = styled(IconHeadphoneSvg)`
  inline-size: 24px;
`;

export const StyledPlayer = styled(Player)`
  display: flex;

  inline-size: 24px;
  block-size: 22px;
`;
